export default __webpack_public_path__ + "static/210512_更新完成_jp-614432f6e225125370ebf1572127592b.webp";